var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBurger = function SvgBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M31.781 5.625H4.22a.28.28 0 0 0-.282.281v2.25c0 .155.127.281.282.281H31.78a.28.28 0 0 0 .282-.28v-2.25a.28.28 0 0 0-.282-.282m0 21.938H4.22a.28.28 0 0 0-.282.28v2.25c0 .155.127.282.282.282H31.78a.28.28 0 0 0 .282-.281v-2.25a.28.28 0 0 0-.282-.282m0-10.97H4.22a.28.28 0 0 0-.282.282v2.25c0 .155.127.281.282.281H31.78a.28.28 0 0 0 .282-.281v-2.25a.28.28 0 0 0-.282-.281"
  })));
};
export default SvgBurger;